import type { IStorage } from "@interfaces";
import { PriceItem } from "@src/domain/price";
import { ItemStorageFactory } from "./itemStorage";

export const priceItem = ({ storage }: { storage: IStorage }) =>
	ItemStorageFactory<PriceItem>(storage, "pi_v2");
